module.exports = __webpack_public_path__ + "static/media/work-1.be3568c2.png";